import { InfoFilledIcon } from '@calizahq/react-components-v2'
import React from 'react'
import { Link } from 'react-router-dom'

export const PropertyListColumns = [
  {
    Header: 'Property',
    accessor: 'name',
    width: 30,
    Cell: function _Cell({ value }: any) {
      return (
        <div className="flex items-center justify-center">
          <div className="flex flex-col font-medium">
            <h3 className="font-bold">{value}</h3>
          </div>
        </div>
      )
    },
  },
  {
    Header: 'Address',
    accessor: 'address1',
    width: 40,
  },
  {
    Header: 'Management Company',
    accessor: (row) => row?.managementCompany?.name,
    width: 40,
  },
  {
    accessor: 'id',
    width: 10,
    Cell: function _Cell({ value }: any) {
      return (
        <div className="ml-auto flex items-center justify-center" title="View Property">
          <Link to={`/properties/${value}`}>
            <InfoFilledIcon className="ml-2 text-green-300" height={24} width={24} />
          </Link>
        </div>
      )
    },
  },
]
